<template>
  <div class="home">

<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">
  <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">
  <meta name="renderer" content="webkit">
  <meta name="keywords" content="登录720云全景摄影网，720全景，360全景，360度全景，全景网，全景摄影，全景拍摄，航拍，VR全景，虚拟现实，街景，全景图片，全景视频">
  <meta name="description" content="登录720云，一站式专业全景工具平台，聚合VR全景、虚拟现实领域内海量优质全景内容、全景图片、全景摄影师、航拍全景、360度全景、及正版版权全景图片市场" id="metaDescription">
  <meta name="robots" content="all">
  <meta property="wb:webmaster" content="1589f8e64ea3ca3a">
  <title>登录 - 登录720云账号，720云-一站式专业全景平台，为您呈现全景摄影、全景视频、全景航拍、全景效果图，360度全方位的VR展示与体验-720yun</title>
  <link rel="shortcut icon" href="https://ssl-static.720static.com/favicon.ico">
  <link rel="stylesheet" type="text/css" href="https://ssl-static.720static.com/css/common.3369d1693fcc620a5885.css">
  <link rel="stylesheet" type="text/css" href="https://ssl-static.720static.com/css/login.fb3cf12af4c5a8594f0b.css">
</head>
  <div id="app"><div class="App_bg_MTCINY"><div class="KrPano_kr_amKYw9"><div id="panoContainer" class="KrPano_content_1OQfor"><div id="krpanoSWFObject" tabindex="-1" style="position: relative; overflow: hidden; height: 100%; line-height: normal; font-weight: normal; font-style: normal; outline: 0px; -webkit-tap-highlight-color: transparent; background: rgb(0, 0, 0); width: 100%;"><div style="position: absolute; left: 0px; top: 0px; width: 911px; height: 978px; overflow: hidden; user-select: none; touch-action: none; -webkit-tap-highlight-color: transparent; cursor: default;"><div style="position: absolute; left: 0px; top: 0px; width: 100%; height: 100%; overflow: hidden; pointer-events: none;"><canvas width="911" height="978" style="position: absolute; left: 0px; top: 0px; width: 911px; height: 978px;"></canvas></div><div style="position: absolute; left: 0px; top: 0px; width: 100%; height: 100%; overflow: hidden; user-select: none; transform-style: preserve-3d;"><div style="display: none; position: absolute; z-index: 3091; overflow: visible; opacity: 1; cursor: pointer; pointer-events: auto;"></div><div style="position: absolute; z-index: 3011; overflow: visible; opacity: 1; background: none; cursor: default; pointer-events: none; border-style: solid; border-color: rgb(0, 0, 0); border-width: 0px; border-radius: 0px; width: 911px; height: 978px; transform: translateZ(1e+12px) translate(0px, 0px) translate(-455.5px, -489px) rotate(0deg) translate(455.5px, 489px);"><div style="position: absolute; z-index: 3011; overflow: visible; opacity: 1; cursor: default; pointer-events: none; background: none; border-style: solid; border-color: rgb(0, 0, 0); border-width: 0px; border-radius: 0px; width: 911px; height: 978px; transform: translateZ(1e+12px) translate(0px, 0px) translate(455.5px, -489px) rotate(0deg) translate(-455.5px, 489px);"></div></div><div style="display: none; position: absolute; z-index: 3001; overflow: visible; opacity: 1; cursor: default; pointer-events: none;"></div><div style="display: none; position: absolute; z-index: 3001; overflow: visible; opacity: 1; cursor: pointer; pointer-events: auto;"></div><div style="display: none; position: absolute; z-index: 3001; overflow: visible; opacity: 0; color: rgb(0, 0, 0); text-size-adjust: none; pointer-events: auto; background: none; cursor: pointer; width: 93px; height: 39px; transform: translateZ(1e+12px) translate(409px, 24px) translate(0px, -19.5px) rotate(0deg) translate(0px, 19.5px);"><div style="position: absolute; top: 0px; left: 0px; transform-origin: 0px 0px; transform: scale(1); width: 100%; height: 100%; font-size: 12px; font-family: Arial; line-height: normal; color: rgb(0, 0, 0); pointer-events: none; visibility: visible;"><div style="position: absolute; white-space: nowrap; background-color: rgba(0, 0, 0, 0.5);"><div style="margin:6px 10px 6px 10px;color:#FFFFFF;font-size:20px;">退出 VR</div></div></div></div><div style="display: none; position: absolute; z-index: 3001; overflow: visible; opacity: 0; color: rgb(0, 0, 0); text-size-adjust: none; pointer-events: auto; background: none; cursor: pointer; width: 93px; height: 39px; transform: translateZ(1e+12px) translate(409px, 829px) translate(0px, 19.5px) rotate(0deg) translate(0px, -19.5px);"><div style="position: absolute; top: 0px; left: 0px; transform-origin: 0px 0px; transform: scale(1); width: 100%; height: 100%; font-size: 12px; font-family: Arial; line-height: normal; color: rgb(0, 0, 0); pointer-events: none; visibility: visible;"><div style="position: absolute; white-space: nowrap; background-color: rgba(0, 0, 0, 0.5);"><div style="margin:6px 10px 6px 10px;color:#FFFFFF;font-size:20px;">VR 设置</div></div></div></div></div></div><div style="position: absolute; left: 0px; bottom: -1px; width: 100%; height: 156px; overflow: hidden; display: none; transform: translateZ(2e+12px); z-index: 999999999;"><div style="position: absolute; left: 0px; top: 0px; width: 100%; height: 100%; overflow: hidden; background-color: rgb(0, 0, 0); box-sizing: border-box; border-top: 1px solid rgba(255, 255, 255, 0.8); border-bottom: 1px solid rgba(255, 255, 255, 0.8); opacity: 0.6;"></div><pre style="position: absolute; left: 5px; top: 0px; margin: 6px 0px; padding: 0px 16px 0px 0px; border: 0px; border-radius: 0px; width: 100%; height: 146px; overflow: hidden auto; text-align: left; white-space: pre-line; text-size-adjust: none; cursor: text; display: block !important; background: none !important; font-family: &quot;Courier New&quot; !important; font-size: 11px !important; line-height: 1.2 !important; color: rgb(255, 255, 255) !important;"><div>INFO: krpano 1.20.2 (build 2019-10-15)</div><div>INFO: HTML5/Desktop - Chrome 74.0 - WebGL</div><div>INFO: Registered to: OTHINK Technology Co.,Ltd.</div></pre><div style="position: absolute; right: 0px; top: 6px; padding: 0px 4px; height: 30px; user-select: none; cursor: pointer; -webkit-tap-highlight-color: transparent; font-family: &quot;Courier New&quot;; font-size: 10px; color: rgb(255, 255, 255);">CLOSE</div><div style="position: absolute; right: 2px; bottom: 4px; padding: 0px 4px 4px; height: 14px; user-select: none; cursor: pointer; -webkit-tap-highlight-color: transparent; font-family: &quot;Courier New&quot;; font-size: 14px; color: rgb(170, 170, 170);">⇵</div><div style="position: absolute; right: 0px; bottom: 18px; padding: 0px 4px 4px; height: 12px; user-select: none; cursor: pointer; -webkit-tap-highlight-color: transparent; font-family: &quot;Courier New&quot;; font-size: 10px; color: rgb(15, 255, 0); display: none;">LAYERS</div><div style="position: absolute; right: 0px; bottom: 36px; padding: 4px 4px 0px; height: 12px; user-select: none; cursor: pointer; -webkit-tap-highlight-color: transparent; font-family: &quot;Courier New&quot;; font-size: 10px; color: rgb(15, 255, 0); display: none;">HOTSPOTS</div><div style="position: absolute; right: 0px; bottom: 50px; padding: 4px 4px 0px; height: 12px; user-select: none; cursor: pointer; -webkit-tap-highlight-color: transparent; font-family: &quot;Courier New&quot;; font-size: 10px; color: rgb(15, 255, 0); display: none;">PANO</div></div></div></div><img id="panoLoading" class="KrPano_krloading_as0OpI" src="data:image/png;base64,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" style="display: none;"><div class="Author_author_2JROmU"><a href="https://720yun.com/u/a19jOdtkvv1" target="_blank" class="LineEllipsis_link_2s2wdM"></a></div></div><div class="App_krpanoBg_36KiMN"></div><div class="Page_page_36KxeD">
    <div class="Page_form_1oz39J" v-if='iszhuce==false'>
      <div class="Page_title_2JTnMl">登 录</div>
      <div class="Page_subtitle_2bZDtM">全景看世界，欢迎您回来</div>
      <div class="LoginPage_group_2yR8T_"><label><input class="LoginPage_input2_3ZL3IW" type="text" placeholder="手机号／邮箱" v-model="name"></label></div>
      <div class="LoginPage_group_2yR8T_"><div class="EyeInput_pw_w41ZtV"><input placeholder="密 码" type="password" class="LoginPage_input_yBbPhy" v-model='pass'><div class="EyeInput_eye_2sCnS8">
    </div></div></div>
    <div @click='login' class="LoginPage_group_2yR8T_"><a href="javascript: void 0;" class="Button_button_9Gj_L9 Button_default_12cP_n" style="width: 308px; height: 40px; padding-left: 0px; padding-right: 0px;">登 录</a></div>
    <div class="LoginPage_help_1ZfQaR" ><div class="LoginPage_r_uCZa1g">
      <a class="LoginPage_blue_lWh0mp" @click='zhuce'>注册</a></div></div>
    </div>
    <div class="Page_form_1oz39J" v-if='iszhuce'>
      <div class="Page_title_2JTnMl">注 册</div>
      <div class="Page_subtitle_2bZDtM">全景看世界，欢迎您回来</div>
      <div class="LoginPage_group_2yR8T_"><label><input class="LoginPage_input2_3ZL3IW" type="text" placeholder="邮箱" v-model="registerName"></label></div>
      <div class="LoginPage_group_2yR8T_"><div class="EyeInput_pw_w41ZtV"><input placeholder="密 码" type="password" class="LoginPage_input_yBbPhy" v-model='registerPass'><div class="EyeInput_eye_2sCnS8">
    </div></div></div>
    <div class="LoginPage_group_2yR8T_"><div class="EyeInput_pw_w41ZtV"><input placeholder="请再次输入密码" type="password" class="LoginPage_input_yBbPhy" v-model='conpass'><div class="EyeInput_eye_2sCnS8">
    </div></div></div>
    <div @click='register' class="LoginPage_group_2yR8T_"><a href="javascript: void 0;" class="Button_button_9Gj_L9 Button_default_12cP_n" style="width: 308px; height: 40px; padding-left: 0px; padding-right: 0px;">注 册</a></div>
    <div class="LoginPage_help_1ZfQaR" ><div class="LoginPage_r_uCZa1g">
      <a class="LoginPage_blue_lWh0mp" @click='gologin'>已有账号，请登录</a></div></div>
    </div>
    </div></div></div>
  <div class="coss">
  <a href="http://xr.baidu.com" title="百度XR" target="_blank">百度XR</a><a href="https://www.picovr.com" title="pico" target="_blank">pico</a><a href="http://www.3dbobovr.com" title="3D播播" target="_blank">3D播播</a><a href="http://www.utovr.com" title="utovr" target="_blank">utovr</a><a href="http://vrbrowser.qq.com" title="qq浏览vr" target="_blank">qq浏览vr</a><a href="http://www.jia.com/beijing/" title="北京装修" target="_blank">北京装修</a><a href="https://www.ximalaya.com/lvyou/" title="景点讲解" target="_blank">景点讲解</a><a href="http://vr.iqiyi.com/" title="爱奇艺VR" target="_blank">爱奇艺VR</a><a href="http://life.iqiyi.com" title="爱奇艺生活" target="_blank">爱奇艺生活</a><a href="https://www.teche720.com/" title="泰科易" target="_blank">泰科易</a>
  </div>
  </div>
</template>
<script src="https://cdn.bootcss.com/babel-polyfill/7.6.0/polyfill.min.js"></script>
<script src="https://ssl-player.720static.com/krp/1.20.2/krp_player_1.20.2.1.js"></script>
<script src="https://ssl-static.720static.com/js/common.4e63cfa8188f4269ea38.js"></script>
<script src="https://ssl-static.720static.com/js/login.dfd524e7e163dfaca77e.js"></script>

<script>
import https from "../https.js";
import axios from "axios";
export default {
  name: "",
  components: {
  },
  data() {
    return {
      name:'',
      pass:'',
      iszhuce:false,
      registerName:'',
      registerPass:'',
      conpass:''
    };
  },
  mounted() {
    var id = this.$route.query.id
    if(id==2){
      this.iszhuce = true
    }
    else{
      this.iszhuce = false
    }
  },
  methods: {
    zhuce(){
        this.iszhuce = true
    },
    gologin(){
        this.iszhuce = false

    },
    register(){
      var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
       if(!reg.test(this.registerName)){
        this.$message({
            type: 'error',
            message: '请输入正确的邮箱',
           duration:1000
          });
      }
      else if(this.registerPass.length<6){
         this.$message({
            type: 'error',
            message: '密码不少于6位',
            duration:1000
          });
      }
      else if(this.registerPass!=this.conpass){
        this.$message({
            type: 'error',
            message: '两次密码不一致',
           duration:1000
          });
      }
      else{
        https
        .fetchPost("/api/User/Register", {'email':this.registerName,'password':this.registerPass})
        .then(res => {
            console.log(res)
            if(res.data.code==200){
                this.$message({
                type: 'success',
                message: '注册成功',
                duration:1000
            });
            }
            else{
               this.$message({
                type: 'error',
                message: '注册失败',
                duration:1000
            });
            }
        })
      }
    },
    login(){
      var reg = /^[0-9a-zA-Z_.-]+[@][0-9a-zA-Z_.-]+([.][a-zA-Z]+){1,2}$/;
      var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
      if (reg.test(this.name)) {
        https
        .fetchPost("/api/User/Login", {'email':this.name,'password':this.pass})
        .then(res => {
            if(typeof(res.data)=='string'){
              this.$message({
                type: 'success',
                message: '登录成功',
                duration:1000
            });

            this.$router.push({path:'/'})
            }
            else{
              this.$message({
                type: 'error',
                message: '登录失败',
                duration:1000
            });
            }
        })
    } else if(myreg.test(this.name)){
        https
        .fetchPost("/api/User/Login", {'phoneNumber':this.name,'password':this.pass})
        .then(res => {
            console.log(res)
            if(typeof(res.data)=='string'){
              this.$message({
                type: 'success',
                message: '登录成功',
                duration:1000
            });
             this.$router.push({path:'/my'})
            }
            else{
              this.$message({
                type: 'error',
                message: '登录失败',
                duration:1000
            });
            }
        })
    }
    else if(!reg.test(this.name)||!myreg.test(this.name)){
          this.$message({
            type: 'error',
            message: '请输入正确的手机号或邮箱',
            duration:1000
          });

    }

    }
  }
};
</script>
<style >
.home,#app{
  height:100%
}
.home{
  background: black;
}
label{
  width: 100%;
}
.Button_default_12cP_n {
    background-color: #286efa;
    color: #fff;
}
.LoginPage_blue_lWh0mp {
    color: #427afb;
    cursor: pointer;
    font-weight: 700;
}
.Button_button_9Gj_L9 {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    height: 30px;
    border-radius: 3px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
input[type="text"], input[type="password"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding-left: 10px;
    padding-right: 10px;
    color: #333;
    border: #e9e9e9 1px solid;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.LoginPage_input_yBbPhy {
    width: 308px;
    height: 40px;
    line-height: 40px;
}
.LoginPage_input2_3ZL3IW {
    width: 100%!important;
    height: 40px;
    line-height: 40px;
}
.Page_form_1oz39J {
    padding: 30px 40px;
    background-color: #fff;
    width: 388px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
}
.Page_title_2JTnMl {
    font-size: 36px;
    text-align: center;
    padding-bottom: 10px;
}
.Page_subtitle_2bZDtM {
    font-weight: bolder;
    text-align: center;
    padding-bottom: 30px;
    line-height: 170%;
}
.LoginPage_group_2yR8T_ {
    display: -webkit-box;
    display: -ms-flexbox;

    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 15px;
}
.LoginPage_help_1ZfQaR {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    line-height: 30px;
}
* {
  box-sizing: border-box;
}
 .coss { width:10rem; height:10rem; overflow:hidden; position: absolute; left: -20rem; top: 0; }
*:before,
*:after {
  box-sizing: border-box;
}
*:focus {
  outline: 0 !important;
}

html {
  font-size: 10px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-family: "PingFangSC-Regular", "Microsoft YaHei",
    "Hiragino Sans GB", tahoma, Arial, "\5B8B\4F53", "STHeiti",
    "WenQuanYi Micro Hei", SimSun, sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  font-family: "PingFangSC-Regular", "Microsoft YaHei",
    "Hiragino Sans GB", tahoma, Arial, "\5B8B\4F53", "STHeiti",
    "WenQuanYi Micro Hei", SimSun, sans-serif;
  font-size: 14px;
  line-height: 1;
  color: #333;
  background-color: #fff;
  word-wrap: break-word;
}

h1,
h2,
h3,
h4 {
  padding: 0;
  margin: 0;
}

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}

button {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
  cursor: pointer;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

input[type="search"] {
  -webkit-appearance: textfield;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  -webkit-text-fill-color: #333;
}

textarea {
  overflow: auto;
  resize: none;
  color: #333;
  padding: 10px;
  border: #e9e9e9 1px solid;
  transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
}

optgroup {
  font-weight: bold;
}

a {
  color: inherit;
  text-decoration: none;
}

a:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

ul,
ol {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

p {
  margin: 0;
}

input[type="text"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-left: 10px;
  padding-right: 10px;
  color: #333;
  border: #e9e9e9 1px solid;
  transition: border-color ease-in-out 0.15s,
    box-shadow ease-in-out 0.15s;
}

textarea:focus,
input[type="text"]:focus,
input[type="password"]:focus {
  border-color: #a0bdfe;
  box-shadow: 0 0 3px 0 #427afb;
}

::placeholder {
  color: #9b9b9b;
}

.list-inline {
  font-size: 0;
}

.list-inline li {
  display: inline-block;
  font-size: 14px;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-height: 1em;
}

.link {
  color: #427afb;
  cursor: pointer;
}

.ReactModal__Body--open {
  overflow: hidden;
}

.container {
  width: 1180px;
  margin: 0 auto;
}

.modal-title {
  font-size: 20px;
  font-weight: normal;
  height: 60px;
  line-height: 60px;
  margin-top: 0;
  margin-bottom: 0;
  background: #f3f3f3;
  border-radius: 6px 6px 0 0;
  border-bottom: 1px solid #d8d8d8;
  padding-left: 20px;
}
.modal-foot {
  border-radius: 0 0 6px 6px;
  background: #f3f3f3;
  text-align: center;
  border-top: 1px solid #d8d8d8;
  height: 60px;
  padding-top: 12px;
}

.tether-element {
  z-index: 100000000000;
}

.modal-open {
  overflow: hidden;
}
.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
  height: 0;
}
.clearfix {
  zoom: 1;
}
.rc-pagination {
  font-size: 14px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.rc-pagination-total-text {
  height: 30px;
  line-height: 30px;
  margin-right: 10px;
}
.rc-pagination:after {
  content: " ";
  display: block;
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.rc-pagination-item {
  position: relative;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  list-style: none;
  background-color: #fff;
  margin-right: 8px;
  display: inline-block;
  padding-left: 6px;
  padding-right: 6px;
}
.rc-pagination-item a {
  text-decoration: none;
  color: #666;
}
.rc-pagination-item:hover {
  border-color: #427afb;
}
.rc-pagination-item:hover a {
  color: #427afb;
}
.rc-pagination-item-active {
  background-color: #427afb;
  border-color: #427afb;
}
.rc-pagination-item-active a {
  color: #fff;
}
.rc-pagination-item-active:hover a {
  color: #fff;
}
.rc-pagination-jump-prev:after,
.rc-pagination-jump-next:after {
  content: "\2022\2022\2022";
  display: block;
  letter-spacing: 2px;
  color: #ccc;
  font-size: 12px;
  margin-top: 1px;
}
.rc-pagination-jump-prev:hover:after,
.rc-pagination-jump-next:hover:after {
  color: #427afb;
}
.rc-pagination-jump-prev:hover:after {
  content: "\AB";
}
.rc-pagination-jump-next:hover:after {
  content: "\BB";
}
.rc-pagination-prev,
.rc-pagination-jump-prev,
.rc-pagination-jump-next {
  margin-right: 8px;
}
.rc-pagination-prev,
.rc-pagination-next,
.rc-pagination-jump-prev,
.rc-pagination-jump-next {
  position: relative;
  cursor: pointer;
  color: #666;
  font-size: 10px;
  list-style: none;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
.rc-pagination-prev a:after {
  content: "\2039";
  display: block;
}
.rc-pagination-next a:after {
  content: "\203A";
  display: block;
}
.rc-pagination-prev,
.rc-pagination-next {
  font-size: 24px;
}
.rc-pagination-prev a,
.rc-pagination-next a {
  color: #666;
}
.rc-pagination-prev a:after,
.rc-pagination-next a:after {
  margin-top: -1px;
}
.rc-pagination-disabled {
  cursor: not-allowed;
}
.rc-pagination-disabled a {
  color: #ccc;
}
.rc-pagination-options {
  margin-left: 15px;
  color: #767676;
}
.rc-pagination-options-size-changer {
  width: 80px;
}
.rc-pagination-options-quick-jumper {
  margin-left: 16px;
  height: 30px;
  line-height: 30px;
}
.rc-pagination-options-quick-jumper input[type="text"] {
  margin: 0 8px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #c2c2c2;
  outline: none;
  padding: 3px 8px;
  width: 60px;
  height: 28px;
  line-height: 28px;
}
.rc-pagination-options-quick-jumper input:hover {
  border-color: #427afb;
}
.rc-pagination-simple .rc-pagination-prev,
.rc-pagination-simple .rc-pagination-next {
  border: none;
  height: 24px;
  line-height: 24px;
  margin: 0;
  font-size: 18px;
}
.rc-pagination-simple .rc-pagination-simple-pager {
  margin-right: 8px;
}
.rc-pagination-simple
  .rc-pagination-simple-pager
  .rc-pagination-slash {
  margin: 0 10px;
}
.rc-pagination-simple .rc-pagination-simple-pager input {
  margin: 0 8px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  outline: none;
  padding: 5px 8px;
  width: 30px;
  min-height: 20px;
}
.rc-pagination-simple .rc-pagination-simple-pager input:hover {
  border-color: #427afb;
}
@media only screen and (max-width: 1024px) {
  .rc-pagination-item-after-jump-prev,
  .rc-pagination-item-before-jump-next {
    display: none;
  }
}
</style><style type="text/css">/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */


html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */

/**
 * Remove the margin in all browsers.
 */

body {
  margin: 0;
}

/**
 * Render the `main` element consistently in IE.
 */

main {
  display: block;
}

/**
 * Correct the font size and margin on `h1` elements within `section` and
 * `article` contexts in Chrome, Firefox, and Safari.
 */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */

/**
 * Remove the gray background on active links in IE 10.
 */

a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */

small {
  font-size: 80%;
}

/**
 * Prevent `sub` and `sup` elements from affecting the line height in
 * all browsers.
 */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */

/**
 * Remove the border on images inside links in IE 10.
 */

img {
  border-style: none;
}

/* Forms
   ========================================================================== */

/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input { /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select { /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from `fieldset` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    `fieldset` elements in all browsers.
 */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */

textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to `inherit` in Safari.
 */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */

/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */

summary {
  display: list-item;
}

/* Misc
   ========================================================================== */

/**
 * Add the correct display in IE 10+.
 */

template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */

[hidden] {
  display: none;
}

</style>

